import { render, staticRenderFns } from "./FeedbackLayer.vue?vue&type=template&id=180f9ced&"
import script from "./FeedbackLayer.vue?vue&type=script&lang=js&"
export * from "./FeedbackLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports